import { combineReducers } from 'redux';

import search, { initialState as searchInitialState } from './search';
import literature from './literature';
import exceptions from './exceptions';
import user, { initialState as userInitialState } from './user';
import submissions from './submissions';
import citations from './citations';
import authors from './authors';
import jobs from './jobs';
import conferences from './conferences';
import institutions from './institutions';
import data from './data';
import seminars from './seminars';
import experiments from './experiments';
import journals from './journals';
import bibliographyGenerator from './bibliographyGenerator';
import settings from './settings';
import ui, { initialState as uiInitialState } from './ui';
import backoffice, {
  initialState as backofficeInitialState,
} from './backoffice';
import recordEditor, {
  initialState as recordEditorInitialState,
} from './recordEditor';
import { LITERATURE_NS, LITERATURE_REFERENCES_NS } from '../search/constants';
import authorlist from './authorlist';

export default function createRootReducer(routerReducer) {
  return combineReducers({
    router: routerReducer,
    exceptions,
    literature,
    user,
    settings,
    search,
    submissions,
    citations,
    authors,
    ui,
    jobs,
    conferences,
    institutions,
    seminars,
    experiments,
    data,
    bibliographyGenerator,
    authorlist,
    journals,
    backoffice,
    recordEditor,
  });
}

export const REDUCERS_TO_PERSISTS = [
  { name: 'ui', initialState: uiInitialState },
  { name: 'user', initialState: userInitialState },
  {
    name: 'search',
    initialState: searchInitialState,
    statePath: ['namespaces', LITERATURE_REFERENCES_NS, 'query', 'size'],
  },
  {
    name: 'search',
    initialState: searchInitialState,
    statePath: ['namespaces', LITERATURE_NS, 'query', 'size'],
  },
  { name: 'backoffice', initialState: backofficeInitialState },
  { name: 'recordEditor', initialState: recordEditorInitialState },
];
